module.exports = __webpack_public_path__ + "img/u60.722b187e.png";